import { CustomTreeNode } from '../../EntitiesTreeSearch.types';

import styles from './TreeNodeTitle.module.scss';

export const RenderTitleNode = (node: CustomTreeNode): React.ReactNode => {
  const { title, className } = node;

  return <span className={styles[className ?? '']}>{title}</span>;
};
